import { endpoint } from "views/pages/manage/common/constant";
import { dropdownMapping } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { DIGITAL_BUSINESS_IDS } from "views/pages/manage/common/hook/useCashierOfficeDropdown";
import InfoIconSolid from "assets/img/svg/svgComponents/InfoIconSolid";
import React from 'react';
import { Tooltip } from '@mui/material';

export const getDropdowns = async () => {
  const dropdown = await Promise.all([
    dropdownMapping(
      endpoint.businessArea.getAllActiveV2,
      "businessAreaDispValue",
      "id",
      "businessAreaDesc"
    ),
    dropdownMapping(
      endpoint.courseCatelogMapping.getAllActiveCourseIds,
      "courseIds"
    ),
    dropdownMapping(endpoint?.term?.getAllActive, "termDispValue", "termDispValue"),
    dropdownMapping(endpoint?.paymentMode?.getActive, "paymentModeKey", "paymentModeKey"),
    dropdownMapping(endpoint?.businessUnitType?.getAllBusinessUnitType, 'businessUnitTypeDispValue', 'id'),
  ]);
  return {
    businessArea: dropdown[0],
    courseIds: dropdown[1],
    terms: dropdown[2],
    paymentMode: dropdown[3],
    branchType: [...(dropdown[4] || []), { label: "Advance", value: "advance" }],
    advanceBusinessAreas: dropdown[0]?.filter(bu => DIGITAL_BUSINESS_IDS.includes(bu?.label))
  };
}



export const FILTER__FORM_FIELDS_GLOBAL = {
  businessArea: [],
  terms: [],
  finalStatus: [],
  refundTypes: [],
  paymentMode: [],
  refundRequestDateFrom: "",
  refundRequestDateTo: "",
  psid: "",
  searchByValue: "",
  searchBy: "",
  cashierOffice: [],
  refundNumber: "",
  applicationId: ""
};

export const SEARCH_BY = [
  {
    key: "psid",
    value: "By PSID",
  },
  {
    key: "refundNumber",
    value: "Refund Request No",
  },
  {
    key: "applicationId",
    value: "Application Id",
  },
  // {
  //   key: "studentPoId",
  //   value: "Student PO Id",
  // },
  // {
  //   key: "loanPoId",
  //   value: "Loan PO Id",
  // },
];



export const refundStatusChipInfo = {
  "completed": { text: "Completed", textColor: "#0B442D", bgColor: "#BBE2CE" },
  "approved": { text: "Approved", textColor: "#0B442D", bgColor: "#BBE2CE" },
  "initiated": { text: "Initiated", textColor: "#A17217", bgColor: "#FFEDC8" },
  "inprogress": { text: "In Progress", textColor: "#A17217", bgColor: "#FFEDC8" },
  "pending": { text: "Pending", textColor: "#A17217", bgColor: "#FFEDC8" },
  "rejected": { text: `Rejected`, textColor: "#B32306", bgColor: "#F9D9D7" },
  "expired": { text: `Expired`, textColor: "#B32306", bgColor: "#F9D9D7" },
  "partialfailed": { text: `Partial Failed`, textColor: "#B32306", bgColor: "#F9D9D7" },
  "failed": { text: `Failed`, textColor: "#B32306", bgColor: "#F9D9D7" }
};


export const getStatusChipInfo = (row, refundReasons) => {

  const { approvalStatus, remark = "", refundStatus, subOrderType, userReasonId } = row;

  const isCompletionRefund = subOrderType?.toLowerCase() === "completion_refund";
  const refundReason = refundReasons?.find(item => item.id === userReasonId)?.label;

  const tooltipText = isCompletionRefund
    ? `${refundReason || ""}${remark ? ` - ${remark}` : ""}`.trim()
    : remark || "-";

  switch (true) {

    case refundStatus?.toLowerCase().includes('completed'): {
      return {
        text: refundStatus,
        bgColor: "#BBE2CE",
        textColor: "#0B442D"
      }
    }

    case refundStatus?.toLowerCase().includes("failed"): {
      const statusKey = refundStatus?.toLowerCase();
      const chip = refundStatusChipInfo[statusKey];
      return {
        text: (
          <span>
            {chip?.text || refundStatus}
            <Tooltip title={tooltipText}>
              <span className='ml-2'><InfoIconSolid color={"#B32306"} /></span>
            </Tooltip>
          </span>
        ),
        bgColor: "#F9D9D7",
        textColor: "#B32306"
      }
    }

    case approvalStatus?.includes("REJECT"): {
      return {
        text: (
          <span>
            Rejected
            <Tooltip title={tooltipText}>
              <span className='ml-2'><InfoIconSolid color={"#B32306"} /></span>
            </Tooltip>
          </span>
        ),
        bgColor: "#F9D9D7",
        textColor: "#B32306"
      }
    }

    case approvalStatus?.includes('PENDING'): {
      const isL1 = approvalStatus?.includes("L1");
      const isL2 = approvalStatus?.includes("L2");
      const text = `Pending at ${isL1 ? 'L1' : isL2 ? 'L2' : 'L3'}`;
      return {
        text: text,
        bgColor: "#FFEDC8",
        textColor: "#A17217"
      }

    }

    case approvalStatus?.includes('APPROVED'): {
      return {
        text: 'Approved',
        bgColor: "#BBE2CE",
        textColor: "#0B442D"
      }

    }

    case approvalStatus?.includes('RECHECK'): {
      return {
        text: 'Sent For Correction',
        bgColor: "#F5F5F5",
        textColor: "#262626"
      }

    }

    case approvalStatus?.includes('SUBMITTED'): {
      return {
        text: (<span>
          Submitted
          <Tooltip title={"Transfer Payment Pending"}>
            <span className='ml-2'><InfoIconSolid color={"#262626"} /></span>
          </Tooltip>
        </span>),
        bgColor: "#F5F5F5",
        textColor: "#262626"
      }
    }

    case (refundStatus?.toLowerCase() === 'expired'): {
      return {
        text: 'Expired',
        bgColor: "#F9D9D7",
        textColor: "#B32306"
      }

    }
    default:
      return {
        text: refundStatus,
        bgColor: "#FFEDC8",
        textColor: "#A17217"
      }


  }

};


export const INTERNAL_REFUND = {
  label: "Internal refund",
  value: [
    "SDJ_ADJUSTMENT",
    "CMP_ADJUSTMENT",
    "ADJ_ADJUSTMENT"
  ]
};
